/* eslint-disable react/prop-types */
import { Modal, Button, Form, FormElement as Input, Alert, Criteria } from '@ux/uxcore2';
import React from 'react';

const emailRegEx = /^\s*[a-z0-9._%+-]+@[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,}\s*$/i;


export default class VaultEmailDialog extends React.Component {

  initialState(props) {
    return {
      modal: false,
      formValid: false,
      plSelected: 0,
      plId: '',
      showAltEmail: false,
      customerNumber: '',
      customerNumberValid: false,
      altEmail: '',
      altEmailValid: false,
      subject: props.subject.replace('{' + props.type + '-title}', props.linkTitle),
      message: props.body.replace('{' + props.type + '-title}', props.linkTitle),
      alertStatus: '',
      alertHeader: '',
      alertMessage: ''
    };
  };

  constructor(props) {
    super(props);

    this.state = this.initialState(props);

    this.onCustomerNumberChange = this.onCustomerNumberChange.bind(this);
    this.onValidCustomerNumberChange = this.onValidCustomerNumberChange.bind(this);
    this.onPrivateLabelChange = this.onPrivateLabelChange.bind(this);
    this.onPlIdChange = this.onPlIdChange.bind(this);
    this.onAddAltEmailClick = this.onAddAltEmailClick.bind(this);
    this.onAltEmailChange = this.onAltEmailChange.bind(this);
    this.onValidAltEmailChange = this.onValidAltEmailChange.bind(this);
    this.onSubjectChange = this.onSubjectChange.bind(this);
    this.onMessageChange = this.onMessageChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.close = this.close.bind(this);
  }

  stripTags(text) {
    return text.replace(/(<([^>]+)>)/ig, '');
  }

  getEmailLink(plId) {
    if (plId === '1') {
      return this.props.link;
    }
    else {
      return this.props.linkReseller.replace('{plId}', plId);
    }
  }

  handleSendEmailResponse(err, resp) {
    if (resp.status === 200) {
      this.setState({
        alertStatus: 'success',
        alertHeader: 'email sent',
        alertMessage: '',
        formValid: false
      });
    }
    else {
      var err = JSON.parse(resp.responseText);
      this.setState({
        alertStatus: 'danger',
        alertHeader: 'Error:',
        alertMessage: err.message
      });
    }
  }

  submitForm(evt) {
    evt.preventDefault();
    if (!this.form.state.valid) {
      return;
    }

    var plId = (this.state.plSelected === 0) ? '1' : this.state.plId;
    var emailBody = this.stripTags(this.state.message).replace('{' + this.props.type +
      '-link}', this.getEmailLink(plId));

    var emailMsg = {
      plId: plId || '1',
      market: this.props.market,
      shopperId: this.state.customerNumber,
      cc: this.state.altEmail,
      subject: this.stripTags(this.state.subject),
      body: emailBody
    };

    var self = this;
    this.props.sendEmail(emailMsg, this.props.type, function(err, resp) {
      self.handleSendEmailResponse(err, resp);
    });
  }

  handleValidCustomerNumber(resp) {
    var data = JSON.parse(resp.responseText);
    var shopperInfo = data.length ? data[0] : data;
    var plId = shopperInfo.privateLabelId ? shopperInfo.privateLabelId.toString() : '';
    this.setState({ plId: plId });
  }

  get validateCustomerNumber() {
    var self = this;
    return value => {
      return new Promise((resolve, reject) => {
        if (/^[0-9a-zA-Z]+$/.test(value)) {
          this.props.verifyCustomerNumber(value, function (err, resp) {
            var data = resp && resp.responseText && JSON.parse(resp.responseText);
            if (data && data[0] && data[0].isValidShopper) {
              // customer number validated
              self.handleValidCustomerNumber(resp);
              resolve(true);
            } else {
              // customer number not valid
              self.setState({ plId: '' });
              reject(resp.responseText);
            }
          });
        } else if (value) {
          // customer number not numeric
          self.setState({ plId: '' });
          reject('not numeric');
        } else {
          // customer number empty
          resolve(true);
        }
      });
    };
  }

  get validateContactRequirements() {
    return value => {
      if (this.state.customerNumber === '' && this.state.altEmail === '') {
        // both customer number and alt email may not be empty
        return false;
      }
      else {
        return true;
      }
    };
  }

  get validateAltEmail() {
    return value => {
      if (!value) {
        // empty alt email
        return true;
      }
      else if (emailRegEx.test(value)) {
        // valid alt email
        return true;
      }
      else {
        // invalid alt email
        return false;
      }
    };
  }

  validatePlId() {
    if (this.state.plSelected === 0) {
      // godaddy selected
      return true;
    }
    else {
      // private label selected
      if (/^[0-9a-zA-Z]+$/.test(this.state.plId)) {
        return true;
      }
      else {
        return false;
      }
    }
  }

  onCustomerNumberChange(evt) {
    this.setState({ customerNumber: evt.target.value });
  }

  onValidCustomerNumberChange(name, isValid) {
    this.setState({ customerNumberValid: isValid });
  }

  onPrivateLabelChange(evt) {
    this.setState({ plSelected: evt.target.selectedIndex });
  }

  onPlIdChange(evt) {
    this.setState({ plId: evt.target.value });
  }

  onAddAltEmailClick(evt) {
    evt.preventDefault();
    this.setState({ showAltEmail: true });
  }

  onAltEmailChange(evt) {
    this.setState({ altEmail: evt.target.value });
  }

  onValidAltEmailChange(name, isValid) {
    this.setState({ altEmailValid: isValid });
  }

  onSubjectChange(evt) {
    this.setState({ subject: evt.target.value });
  }

  onMessageChange(evt) {
    this.setState({ message: evt.target.value });
  }

  customerNumberInput() {
    const validates = this.state.customerNumber !== '' ? this.state.customerNumberValid : null;

    return(
      <div>
        <Criteria.Connect>
          <Input label='Customer #' maxLength={12} value={this.state.customerNumber}
            onChange={this.onCustomerNumberChange} validates={validates} />
          <Criteria value={this.state.customerNumber} onValidChange={this.onValidCustomerNumberChange}>
            <Criteria.Rule validate={this.validateCustomerNumber}>
              Valid customer number if specified
            </Criteria.Rule>
            <Criteria.Rule validate={this.validateContactRequirements}>
              Required if alternate email is empty
            </Criteria.Rule>
          </Criteria>
        </Criteria.Connect>
        <div style={{ display: this.props.type === 'product' ? 'block' : 'none' }}>
          <sup style={{ color: '#ED008C', fontSize: '80%', top: '-25px', whiteSpace: 'nowrap' }}>
            Product page cannot be emailed to customers of resellers
          </sup>
        </div>
      </div>
    );
  }

  privateLabelDropdown() {
    return (
      <fieldset className='form-group' style={{ width: '100%' }}>
        <label>Private Label</label>
        <select className='form-control' defaultValue={0}
          onChange={this.onPrivateLabelChange}>
          <option>GoDaddy</option>
          { this.props.type === 'article' && <option>Private Label</option> }
        </select>
      </fieldset>
    );
  }

  plIdInput() {
    return (
      <Input label='PLID #' maxLength={10} value={this.state.plId}
        onChange={this.onPlIdChange} validates={ this.validatePlId() }/>
    );
  }

  altEmailLabel() {
    return (
      <h5 onClick={this.onAddAltEmailClick}
        style={{ color: '#ED008C', cursor: 'pointer' }}>
          + Add Alternate Email
      </h5>
    );
  }

  altEmailInput() {
    const validates = this.state.altEmail !== '' ? this.state.altEmailValid : null;

    return (
      <Criteria.Connect>
        <Input label='Alternate Email' maxLength={254} value={this.state.altEmail}
          onChange={this.onAltEmailChange} validates={validates} />
        <Criteria value={this.state.altEmail} onValidChange={this.onValidAltEmailChange}>
          <Criteria.Rule validate={this.validateAltEmail}>
            Valid email if specified
          </Criteria.Rule>
          <Criteria.Rule validate={this.validateContactRequirements}>
            Required if customer number is empty
          </Criteria.Rule>
        </Criteria>
      </Criteria.Connect>
    );
  }

  subjectInput() {
    return (
      <div style={{ width: '100%' }}>
        <Input label='Subject' maxLength={150} value={this.state.subject}
          onChange={this.onSubjectChange}
          validates={ this.state.subject.trim().length ? true : false }/>
      </div>
    );
  }

  messageTextArea() {
    return (
      <fieldset className='form-group' style={{ width: '100%' }}>
        <label>Message</label>
        <textarea maxLength='4096' value={this.state.message} onChange={this.onMessageChange}
          className='h5 form-control' style={{ resize: 'none', height: '150px' }}>
        </textarea>
      </fieldset>
    );
  }

  modal() {
    if (!this.state.modal) { return null; }

    return (
      <Modal title={this.props.title} onClose={this.close}>
        <Form ref={ (form) => { this.form = form; } } action='#' onSubmit={this.submitForm}
          onValidChange={ (_, isValid) => { this.setState({ formValid: isValid }); }}>
          <div className='container' style={{ padding: 0 }}>
            <div className='form-row col-md-12' style={{ display: this.state.alertStatus ? 'block' : 'none' }}>
              <Alert icon={this.state.alertStatus} header={this.state.alertHeader}
              message={this.state.alertMessage} dismissible={ true }/>
            </div>
            <div className='form-row col-md-12' style={{ display: 'block' }}>
              <Input label='From' name='from' defaultValue={this.props.from} disabled />
            </div>
            <div className='form-row col-md-12' style={{ padding: 0 }}>
              <div className='col-md-6'>
                { this.customerNumberInput() }
              </div>
              <div className='col-md-4'>
                { this.privateLabelDropdown() }
              </div>
              <div className='col-md-2' style={{ display: this.state.plSelected === 1 ? 'block' : 'none' }}>
                { this.plIdInput() }
              </div>
            </div>
            <div className='form-row col-md-12' style={{ display: this.state.showAltEmail ? 'none' : 'block' }}>
              { this.altEmailLabel() }
            </div>
            <div className='form-row col-md-12' style={{ display: this.state.showAltEmail ? 'block' : 'none' }}>
              { this.altEmailInput() }
            </div>
            <div className='form-row col-md-12'>
              { this.subjectInput() }
            </div>
            <div className='form-row col-md-12'>
              { this.messageTextArea() }
            </div>
            <div className='form-row col-md-12' style={{ minHeight: '10px' }}>
            </div>
            <Button disabled={!this.state.formValid} title='Send' type='submit'>Send</Button>
            <Button title='Cancel' onClick={this.close}>Cancel</Button>
          </div>
        </Form>
      </Modal>
    );
  }

  close() {
    this.setState(this.initialState(this.props));
  }

  render() {
    return (
      <div>
        <Button design='primary' onClick={ () => { this.setState({ modal: true }); } }>
          {this.props.title}
        </Button>
        { this.modal() }
      </div>
    );
  }
}
